import * as React from 'react';
import { useState } from 'react';
import './index.css';
import { getThemeImageSrc, THEME_IMAGES } from '../../../theme';
import { ReactComponent as GtLogo } from '../../../images/groundtruth-logo.svg';
import { ReactComponent as GtLogoText } from '../../../images/groundtruth-logo-text.svg';
import { ReactComponent as EyeIcon } from '../../../images/eye-icon.svg';
import { ReactComponent as EyeClosedIcon } from '../../../images/eye-close-icon.svg';

interface StandardResetPasswordProps {
    error: string;
    resetAction: string;
}

function StandardResetPassword({ error, resetAction }: StandardResetPasswordProps) {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const toggleonfirmPasswordVisibility = () => {
        setConfirmPasswordVisible(!confirmPasswordVisible);
    };
    return (
        <div
            className='standard-reset-password--container'
            style={{
                backgroundImage: `url(${getThemeImageSrc(THEME_IMAGES.LOGIN_BACKGROUND)})`
            }}
        >
            <form className='standard-reset-password--form' method='POST' action={resetAction}>
                <header className='standard-reset-password--header'>
                    <div className='app-logo-main' data-testid='app-logo-main'>
                        <div className='app-logo__img-container'>
                            <GtLogo />
                        </div>
                        <div className='app-logo-main__text'>
                            <GtLogoText />
                            <div>Console</div>
                        </div>
                    </div>
                </header>
                <div className='reset-password--text'>Password Reset</div>
                {error && (
                    <p className='standard-reset-password--error'>
                        <span>Error: </span>
                        {error}
                    </p>
                )}
                <label htmlFor='password'>
                    New password
                    <div className='password-input-container'>
                        <input type={passwordVisible ? 'text' : 'password'} id='password' name='password' required />
                        <span
                            className='toggle-password-btn'
                            onClick={togglePasswordVisibility}
                            aria-label='Toggle password visibility'
                            onKeyDown={() => {}}
                            role='button'
                            tabIndex={0}
                        >
                            {passwordVisible ? <EyeIcon /> : <EyeClosedIcon />}
                        </span>
                    </div>
                </label>
                <label htmlFor='confirm'>
                    Confirm new password
                    <div className='password-input-container'>
                        <input
                            type={confirmPasswordVisible ? 'text' : 'password'}
                            id='confirm'
                            name='confirm'
                            required
                        />
                        <span
                            className='toggle-password-btn'
                            onClick={toggleonfirmPasswordVisibility}
                            onKeyDown={() => {}}
                            aria-label='Toggle password visibility'
                            role='button'
                            tabIndex={0}
                        >
                            {confirmPasswordVisible ? <EyeIcon /> : <EyeClosedIcon />}
                        </span>
                    </div>
                </label>
                <button type='submit' className='standard-reset-password--submit-button'>
                    Reset Password
                </button>
            </form>
        </div>
    );
}

export default StandardResetPassword;
